// RITA-1522 (Nutzungserfassung Phase 3d, Epic RITA-1496) — EIN Rollenhelfer für SUPERADMIN.
//
// Die Rollen stehen im JWT als ein einziger Komma-String ('ADMIN,SUPERADMIN'); jwtDecode gibt
// ihn unverändert weiter (context/CommunicationProvider/authUser.ts). Bis RITA-1522 zerlegte
// Routes.tsx (RequireSuperAdmin) ihn selbst; mit dem Heatmap-Schalter und dem Heatmap-Provider
// gäbe es drei Kopien derselben Regel. Zwei Kopien driften: eine, die zusätzlich Kleinschreibung
// akzeptiert, zeigte ein Bedienelement, das die Route derselben Person verweigert.
//
// Das Gate ist KOSMETISCH. Verbindlich bleibt der Server: usageAccess.ts (USAGE_READ_ROLES) und
// die Whitelist in services/audit/sensitiveReadWhitelist.ts entscheiden über die Daten. Wer hier
// etwas ausblendet, verhindert nur die irreführende Bedienung, nicht den Zugriff.

/** Was der Helfer braucht — das JWT-Feld, so wie es ankommt. */
export interface MitRollen {
  roles?: string | null;
}

/** Rolle mit vollem Lesezugriff auf die Nutzungserfassung (Schreibweise des Servers). */
export const SUPERADMIN_ROLLE = 'SUPERADMIN';

/**
 * Trägt der Nutzer die Rolle SUPERADMIN? Fehlende, leere und unbekannte Werte ergeben false
 * (fail-closed). Verglichen wird je Rolle EXAKT — ein `includes` über den ganzen String hielte
 * auch 'NICHTSUPERADMINX' für einen Treffer.
 */
export const istSuperAdmin = (user: MitRollen | null | undefined): boolean =>
  typeof user?.roles === 'string' &&
  user.roles
    .split(',')
    .map((rolle) => rolle.trim())
    .includes(SUPERADMIN_ROLLE);

export default istSuperAdmin;
